export default "__VITE_ASSET__puGM602z__"